module.exports = __webpack_public_path__ + "img/transaction.d9862fb3.svg";